import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  fi: {
    // Navigation
    home: 'ETUSIVU',
    about: 'MEISTÄ',
    contact: 'YHTEYSTIEDOT',
    orderNow: 'TILAA VERKOSTA',
    
    // Hero Section
    established: 'EST. 2001',
    heroTitle1: 'MILAZZO',
    heroTitle2: 'PIZZA',
    heroSubtitle: 'Herkullisia pizzoja, burgereita ja salaatteja Korsossa.',
    orderOnline: 'Tilaa verkosta',
    bookTable: 'Varaa pöytä',
    
    // About Section
    aboutTitle: 'Tervetuloa Milazzoon',
    aboutText: 'Milazzo on vuodesta 2001 lähtien tarjonnut asiakkailleen unohtumattomia makuelämyksiä herkullisten ruokien ja ystävällisen palvelun avulla. Valikoimastamme löydät monipuolisia pizzoja, burgereita, salaatteja ja paljon muuta. Nopea kotiinkuljetuksemme ja laadukas esillepanomme takaavat parhaan mahdollisen kokemuksen. Olitpa ravintolassa tai kotona, Milazzon maut valmistetaan aina tuoreina ja huolella.',
    
    // Opening Hours
    openingHoursTitle: 'Aukioloajat',
    monday: 'Maanantai - Torstai',
    friday: 'Perjantai',
    saturday: 'Lauantai',
    sunday: 'Sunnuntai',
    monThu: '10:00 - 22:00',
    friTime: '10:00 - 22:30',
    satTime: '11:00 - 22:30',
    sunTime: '11:00 - 22:00',
    
    // Contact
    contactTitle: 'Ota yhteyttä',
    address: 'Osoite',
    phone: 'Puhelin',
    email: 'Sähköposti',
    location: 'Korso, Vantaa',
    
    // Footer
    followUs: 'Seuraa meitä',
    allRightsReserved: 'Kaikki oikeudet pidätetään.',
  },
  en: {
    // Navigation
    home: 'HOME',
    about: 'ABOUT US',
    contact: 'CONTACT',
    orderNow: 'ORDER NOW',
    
    // Hero Section
    established: 'EST. 2001',
    heroTitle1: 'MILAZZO',
    heroTitle2: 'PIZZA',
    heroSubtitle: 'Delicious pizzas, burgers and salads in Korso.',
    orderOnline: 'Order Online',
    bookTable: 'Book a Table',
    
    // About Section
    aboutTitle: 'Welcome to Milazzo',
    aboutText: 'Since 2001, Milazzo has been offering our customers unforgettable taste experiences through delicious food and friendly service. Our menu features a wide variety of pizzas, burgers, salads and much more. Our fast home delivery and quality presentation ensure the best possible experience. Whether at the restaurant or at home, Milazzo\'s flavors are always prepared fresh and with care.',
    
    // Opening Hours
    openingHoursTitle: 'Opening Hours',
    monday: 'Monday - Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    monThu: '10:00 AM - 10:00 PM',
    friTime: '10:00 AM - 10:30 PM',
    satTime: '11:00 AM - 10:30 PM',
    sunTime: '11:00 AM - 10:00 PM',
    
    // Contact
    contactTitle: 'Get in Touch',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    location: 'Korso, Vantaa',
    
    // Footer
    followUs: 'Follow Us',
    allRightsReserved: 'All rights reserved.',
  },
  sv: {
    // Navigation
    home: 'HEM',
    about: 'OM OSS',
    contact: 'KONTAKT',
    orderNow: 'BESTÄLL NU',
    
    // Hero Section
    established: 'EST. 2001',
    heroTitle1: 'MILAZZO',
    heroTitle2: 'PIZZA',
    heroSubtitle: 'Läckra pizzor, hamburgare och sallader i Korso.',
    orderOnline: 'Beställ Online',
    bookTable: 'Boka Bord',
    
    // About Section
    aboutTitle: 'Välkommen till Milazzo',
    aboutText: 'Sedan 2001 har Milazzo erbjudit våra kunder oförglömliga smakupplevelser genom läcker mat och vänlig service. Vår meny innehåller ett brett utbud av pizzor, hamburgare, sallader och mycket mer. Vår snabba hemleverans och kvalitetspresentation garanterar bästa möjliga upplevelse. Oavsett om du är på restaurangen eller hemma, Milazzos smaker tillagas alltid färskt och med omsorg.',
    
    // Opening Hours
    openingHoursTitle: 'Öppettider',
    monday: 'Måndag - Torsdag',
    friday: 'Fredag',
    saturday: 'Lördag',
    sunday: 'Söndag',
    monThu: '10:00 - 22:00',
    friTime: '10:00 - 22:30',
    satTime: '11:00 - 22:30',
    sunTime: '11:00 - 22:00',
    
    // Contact
    contactTitle: 'Kontakta Oss',
    address: 'Adress',
    phone: 'Telefon',
    email: 'E-post',
    location: 'Korso, Vantaa',
    
    // Footer
    followUs: 'Följ Oss',
    allRightsReserved: 'Alla rättigheter förbehållna.',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fi');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage && translations[savedLanguage]) {
      setLanguage(savedLanguage);
    }
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};